import api from 'services/api'
import {SEND_MAIL_TO_USER, GET_EMAILS_LIST} from '../endpoints'

export const getEmailsList = async (body) => await api.post(GET_EMAILS_LIST, body)

export const sendMailToUser = async (values) =>
  await api.post(SEND_MAIL_TO_USER, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
